export default __webpack_public_path__ + "static/media/tallify-multiple-godowns.5fc5e915.png";